module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "20px 0 0 0"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Simple Exercises")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch003#copyright-information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#my-poems-in-english",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Poems in English")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#on-the-morning-train",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Morning Train")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#sunday-morning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday Morning")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#restaurant-by-the-sea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Restaurant by the Sea")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#last-day-of-holidays",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Day of Holidays")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#a-quiet-hour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Quiet Hour")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#post-meridiem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post Meridiem")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#self-portrait",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Portrait")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#a-cut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cut")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#a-cold-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cold Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#a-cup-of-tea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cup of Tea")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#return-from-school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return from School")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#they-died-just-below-the-summit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Died Just Below the Summit")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#light",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#now",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#i-found-you-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Found You, God!")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#soprano",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soprano")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#after-a-party",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After a Party")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#how-a-diamond-feels",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How a Diamond Feels")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#wheelers-hill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wheelers Hill")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#men-everywhere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Men Everywhere")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#view-from-museum-station",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("View from Museum Station")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#changing-trains-at-richmond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changing Trains at Richmond")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#a-little-girl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Little Girl")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#view-from-syndal-station",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("View from Syndal Station")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#collins-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collins Street")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#melbourne-late-autumn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Melbourne, Late Autumn")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#there-is-no-reason",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There Is No Reason")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#shoes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoes")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#dreaming-fishermen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dreaming Fishermen")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#faurés-requiem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fauré’s Requiem")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0